import React from 'react';

import CoproManaging from '../../components/Analyzing/CoproManaging';

function CoproManagingView() {
  return (
    <CoproManaging />
  );
}

export default CoproManagingView;
